import { STORAGE } from "@constants/Storage";
import { PATHS } from "@constants/Paths";
import { ALL_DISCOVER_ACTIONS, DEMO_ACTIONS, ORG_ADMIN_ACTIONS } from "@constants/Policies";
export const getUserContext = () => {
    let userContext = null;
    try {
        const userDetailsString = sessionStorage.getItem(STORAGE.USER_CONTEXT);
        userContext = (userDetailsString && JSON.parse(userDetailsString)) || null;
    }
    catch (_a) {
        console.log("Session Storage access issue!!!");
    }
    return userContext;
};
export const storeUserContext = (useContext) => {
    try {
        sessionStorage.setItem(STORAGE.USER_CONTEXT, JSON.stringify(useContext));
    }
    catch (_a) {
        console.log("Session Storage access issue!!!");
    }
};
export const getIsAdmin = (user) => (user === null || user === void 0 ? void 0 : user.roleAlias) === "admin";
const hasDiscoverRole = (user, alias) => {
    const { discoverRole, discoverRoleAlias } = user || {};
    if (discoverRoleAlias === alias)
        return true;
    if (typeof discoverRole === "string")
        return discoverRole === alias;
    return (discoverRole === null || discoverRole === void 0 ? void 0 : discoverRole.alias) === alias;
};
export const getIsDemoUser = (user) => hasDiscoverRole(user, "discover_demo");
export const getIsViewerUser = (user) => hasDiscoverRole(user, "discover_viewer");
export const getIsDiscoverAdmin = (user) => hasDiscoverRole(user, "discover_admin");
export const isAdminUser = (userContext) => {
    if (userContext) {
        return getIsAdmin(userContext === null || userContext === void 0 ? void 0 : userContext.user);
    }
    return false;
};
export const getRedirectPathAfterLogin = (user) => {
    return getIsAdmin(user) ? PATHS.ADMIN_DASHBOARD : PATHS.HOME;
};
export const generateAllowedActions = ({ user }) => {
    if (getIsAdmin(user))
        return [...ALL_DISCOVER_ACTIONS];
    if (getIsDemoUser(user))
        return [...DEMO_ACTIONS];
    if (getIsDiscoverAdmin(user))
        return [...ORG_ADMIN_ACTIONS];
    return [];
};
